import Footer from "../../components/footer/footer"
import Header from "../../components/header/header"
import RegisterSection from "../../components/provider_register/register"
import SearchModel from "../../components/search_model/search"

const ProviderRegister = () => {
    return (
        <>
            <Header />
            <RegisterSection />
            <Footer />
            <SearchModel/>
        </>
    )
}

export default ProviderRegister